import { JSX } from 'react'

import { IconProps } from '../../icon'

const Plastica: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M23.0195 8.45325H15.8672V37.7927H23.0195V8.45325Z'
      fill='#F9D865'
    />
    <path
      d='M34.956 34.6197L32.5213 38.2462L30.8978 34.6197V12.0797H34.956V34.6197Z'
      fill='#AAD3DC'
    />
    <path
      d='M34.956 11.9547V10.2665C34.956 9.265 34.3823 8.45325 33.6745 8.45325H32.1793C31.4715 8.45325 30.8978 9.265 30.8978 10.2665V11.955H34.956V11.9547Z'
      fill='#D7D861'
    />
    <path
      d='M13.5 38.2463H23.4725V8H13.5V38.2463ZM14.4065 8.9065H22.5658V10.4307H18.4862V11.3372H22.566V12.6972H20.375V13.6038H22.566V14.9637H18.4862V15.8703H22.566V17.2303H20.375V18.1368H22.566V19.4967H18.4862V20.4032H22.566V21.7633H20.375V22.6698H22.566V24.0298H18.4862V24.9363H22.566V26.2962H20.375V27.2027H22.566V28.5627H18.4862V29.4692H22.566V30.8293H20.375V31.7358H22.566V33.0958H18.4862V34.0023H22.566V35.3622H20.375V36.2687H22.566V37.3395H14.4065V8.9065ZM33.143 8H31.0275C29.7778 8 28.761 9.01675 28.761 10.2665V34.7512L32.0853 40L35.4095 34.7512V10.2665C35.4095 9.01675 34.3927 8 33.143 8ZM29.6675 12.533H30.7253V34.1665H29.6675V12.533ZM32.0853 38.3055L30.038 35.073H34.1327L32.0853 38.3055ZM31.632 34.1665V12.533H32.5385V34.1665H31.632ZM34.503 34.1665H33.4452V12.533H34.503V34.1665ZM34.503 11.6265H29.6675V10.2665C29.6675 9.5165 30.2775 8.9065 31.0275 8.9065H33.143C33.893 8.9065 34.503 9.5165 34.503 10.2665V11.6265Z'
      fill='black'
    />
  </svg>
)

export default Plastica
